
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partnerships/[slug]",
      function () {
        return require("private-next-pages/partnerships/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partnerships/[slug]"])
      });
    }
  